import { PropertyOfferDTO } from "../DTO/propertyOfferDTO";
import { Address } from "./address";

export class PropertyOffer{
    public id? : number;
    public propertyId! : string;
    public header? : string;
    public address? : Address;
    public imageReference? : string;
    public views? : number;
    public auctionId? : number;
    public auctionType? : number;
    public auctionStatus! : number;
    public auctionEnding? : Date;
    public currentPrice? : number;
    public currentHighBid? : number;
    public currentOffer? : number;
    public highBidder : boolean =false ;
    public documentIdList? : DocumentId[];

    constructor(){
    }

    public static mapToDTO(param:PropertyOffer) : PropertyOfferDTO{
        
        let dto = new PropertyOfferDTO();
        try
        {
            dto.id = param.id;
            dto.propertyId = param.propertyId;
            dto.header = param.header;
            if(param.address) dto.address = Address.mapToDTO(param.address);
            dto.imageReference = param.imageReference;
            dto.views = param.views;
            dto.auctionId = param.auctionId;
            dto.auctionType = param.auctionType;
            dto.auctionStatus = param.auctionStatus;
            if(param.auctionEnding) dto.auctionEnding = param.auctionEnding.toISOString();
            dto.currentPrice = param.currentPrice;
            dto.currentHighBid = param.currentHighBid;
            dto.currentOffer = param.currentOffer;
            dto.highBidder = param.highBidder;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:PropertyOfferDTO) : PropertyOffer
    {
        
        let obj = new PropertyOffer();
        try
        {
            obj.id = param.id;
            obj.propertyId = param.propertyId;
            obj.header = param.header;
            if(param.address) obj.address = Address.mapFromDTO(param.address);
            obj.imageReference = param.imageReference;
            obj.views = param.views;
            obj.auctionId = param.auctionId;
            obj.auctionType = param.auctionType;
            obj.auctionStatus = param.auctionStatus;
            if(param.auctionEnding) obj.auctionEnding = new Date(param.auctionEnding);
            obj.currentPrice = param.currentPrice;
            obj.currentHighBid = param.currentHighBid;
            obj.currentOffer = param.currentOffer;
            obj.highBidder = param.highBidder;
            if(param.documentIdList && param.documentIdList.length>0){
                obj.documentIdList = new Array<DocumentId>(0);
                param.documentIdList.forEach(element => {
                    let doc = new DocumentId();
                    doc.id = element.id;
                    doc.added = new Date(element.added);
                    obj.documentIdList!.push(doc);
                });
            }
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    get formattedAddress():string{
        if(!this.address) return '';
        return this.address.streetAddress1 + ', ' + ((this.address.streetAddress2?.length)?(this.address.streetAddress2 +', '):'') + this.address.city + ', ' + this.address.state + ' ' + this.address.zipCode;
    }

    get auctionEnded():boolean{
        return this.auctionEnding?(this.auctionEnding.getTime()< (new Date()).getTime()):false;
    }

    get auctionEndString():string{
        return this.auctionEnded?"Auction Ended":"Auction Ending";
    }

    get auctionEndingUnix():number|undefined{
        return this.auctionEnding?.getTime();
    }

    get status():string[]{
        //the following will need a different logic, once we know more about status
        let result = new Array<string>(0);
        if(this.auctionType==1 && this.highBidder==true){
            result.push("High Bidder");
        }
        else if(this.auctionType==1 && this.highBidder==false){
            result.push("Outbid");
        }
        else if(this.auctionType==3 || this.auctionType==4){
            result.push("Offer Submitted");
        }
        if(this.auctionStatus===3){
            result.push("Sale Pending");
        }
        if((this.auctionType==1 || this.auctionType==4) && this.auctionEnded){
            result.push("Ended");
        }
        else if(this.auctionStatus>3){
            result.push("Ended");
        }
        return result;
    }
}

export class DocumentId{
    public id! : number;
    public added! : Date;
}